// Avoid `console` errors in browsers that lack a console.
(function () {
	var method;
	var noop = function noop() {};
	var methods = [
		'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
		'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
		'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
		'timeStamp', 'trace', 'warn'
	];
	var length = methods.length;
	var console = (window.console = window.console || {});

	while (length--) {
		method = methods[length];

		// Only stub undefined methods.
		if (!console[method]) {
			console[method] = noop;
		}
	}
}());

// Place any jQuery/helper plugins in here.
(function ($) {
	$(function () {
		$('[data-ride="carousel"]').each(function () {
			var id = '#' + $(this).attr('id');
			setCarouselHeight(id);
		});

		$(document).on('click', '.main-navigation.toggled .menu-item-has-children > a', function (e) {
			var $t = $(this);

			if (e.offsetX > $t.width() / 3 * 2) {
				e.preventDefault();
				$t.parent().toggleClass('open');
			}
		});
	});

	// sets Carousel height to highest item's height
	function setCarouselHeight(id)
	{
		var slideHeight = [];
		$(id + ' .item').each(function ()
		{
			// add all slide heights to an array
			slideHeight.push($(this).height());
		});

		// find the tallest item
		max = Math.max.apply(null, slideHeight);

		// set the slide's height
		$(id + ' .item-content').each(function ()
		{
			$(this).css('height', max + 'px');
		});
	}

	var scroll = new SmoothScroll('a[href*="#"]', {
		header: 'header',
		speed: 200,
	});

	if (location.hash) {
		var target = document.querySelector(location.hash);
		$(window).load(function () {
			scroll.animateScroll(target);
		})
	}

	$('.site-header').on('affix.bs.affix', function () {
		$('.eden-logo').addClass('affixed');
	}).on('affix-top.bs.affix', function () {
		$('.eden-logo').removeClass('affixed');
	}).affix({
		offset: {
			top: function () {
				return (this.top = $('.site-header').offset().top)
			},
		},
	});
})(jQuery);
